import { render, staticRenderFns } from "./Messages.vue?vue&type=template&id=209401d2&scoped=true&"
import script from "./Messages.vue?vue&type=script&lang=ts&"
export * from "./Messages.vue?vue&type=script&lang=ts&"
import style0 from "./Messages.vue?vue&type=style&index=0&id=209401d2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "209401d2",
  null
  
)

export default component.exports